import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, map, Observable } from 'rxjs';
import { LoginSignupService } from 'src/app/services/login-signup.service';
import { StorageService } from 'src/app/services/storage.service';
import { Location } from '@angular/common';
import { ToasterService } from 'src/app/services/toaster.service';
import { HotelService } from 'src/app/services/hotel.service';
import { AppContext } from 'src/app/services/app-context.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SupabaseService } from 'src/app/services/supabase.service';
import { environment } from 'src/environments/environment';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { DataLayerEvent } from 'types';
declare const gtag: Function;

@Component({
  selector: 'travel-ui-login-signup',
  templateUrl: './login-signup.component.html',
  styleUrls: ['./login-signup.component.scss']
})
export class LoginSignupComponent implements OnInit {
  loginPassHide = true;
  signupPassHide = true;
  signupPassConfHide = true;
  loginForm!: UntypedFormGroup;
  signupForm!: UntypedFormGroup;
  loginSubmit!: boolean;
  signupSubmit!: boolean
  loginpage!: boolean;
  signuppage!: boolean;
  Showloader: boolean = false;
  loginLoader: boolean = false;
  userDetails: any;
  mobileView: boolean = false;
  googleLoginKey: string = environment.supabaseCreds.filter((keyConfiguration) => keyConfiguration.accountId === this.appContext.siteAccountId)[0].googleLoginKeys || "";
  isLoading: boolean = true;
  tagManagerId: string = "";
  isModalLoginPage: boolean = true;
  isModal: boolean = false;
  displaySetting: any;
  constructor(
    private supabaseService: SupabaseService,
    private breakpointObserver: BreakpointObserver,
    public appContext: AppContext,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private loginsignupService: LoginSignupService,
    private storage: StorageService,
    private route: ActivatedRoute,
    private location: Location,
    private toasterSvc: ToasterService,
    private hotelservice: HotelService,
    public dialog: MatDialog,
  ) {
    this.formInitializer();
    this.storage.userDetails.subscribe((user: any) => {
      this.userDetails = user;
    })

    this.isHandset$.subscribe((isMobile) => {
      this.mobileView = isMobile;
    });

    const str = JSON.parse(sessionStorage.getItem('SiteContext') || '{}');
    this.tagManagerId = str?.displaySetting?.googleAnalyticsCode;
    this.displaySetting = str?.displaySetting;
  }

  openResetPassDialog() {
    this.dialog.open(ResetPasswordComponent, { minHeight: '60vh', maxWidth: '70vw', minWidth: '400px' });
  }

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map((result) => result.matches));

  formInitializer() {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email],],
      password: ['', [
        Validators.required]],

    });

    this.signupForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email],],
      password: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/), Validators.minLength(8)]],
      confirmPassword: ['', [
        Validators.required]],
    });
  }

  async handleSignInWithGoogle(credential: string) {
    const { data, error } = await this.supabaseService.supabase.auth.signInWithIdToken({
      provider: 'google',
      token: credential,
    });

    if (error) {
      this.toasterSvc.error(error.message);
      return;
    }
    if (data?.user) {
      const user = data.user;
      if (user?.email) {
        if (this.tagManagerId) {
          gtag('event', 'login', {
            'value': this.loginForm.value.email
          });
        }

        const date = new Date();
        date.setTime(data.session.expires_in);
        localStorage.setItem('token', data.session.access_token);
        localStorage.setItem(
          'refreshToken',
          data.session.refresh_token
        );
        if (this.appContext.siteName == 'ShamalGroup') {
          document.cookie =
            `token= ${data.session.access_token}; domain=.shamal.com; expires=` +
            date +
            `; SameSite=none; Secure=false`;
          document.cookie =
            `refreshToken= ${data.session.refresh_token}; domain=.shamal.com; expires=` +
            date +
            `; SameSite=none; Secure=false`;
        }
        if (this.appContext.siteName == 'Gocaribbea') {
          document.cookie =
            `token= ${data.session.access_token}; domain=.gocaribbea.com; expires=` +
            date +
            `; SameSite=none; Secure=false`;
          document.cookie =
            `refreshToken= ${data.session.refresh_token}; domain=.gocaribbea.com; expires=` +
            date +
            `; SameSite=none; Secure=false`;
        }

        this.storage.setUser(user);
        this.dialog.closeAll();
        if (this.appContext.siteName === 'alldotgay') {
          this.goTo('/');
        } else if (this.storage.getUrl()) {
          window.location.href = this.storage.getUrl();
        } else {
          this.goTo('/');
        }
      }
    }
  }

  setScriptLoaded(resolve: Function) {
    const existingScript = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
    if (existingScript?.isConnected) {
      resolve(true);
      return;
    }
    setTimeout(() => { this.setScriptLoaded(resolve) }, 100)
  }

  async loadScript(name: string): Promise<boolean> {
    return new Promise((resolve, error) => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = name;
      script.async = true;
      document.getElementById('google-login')?.appendChild(script);
      this.setScriptLoaded(resolve);
    });
  }

  async ngOnInit() {
    await this.loadScript('https://accounts.google.com/gsi/client');
    this.isLoading = false;
    const currentUrl = this.router.url;
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email],],
      password: ['', [
        Validators.required]],
    });


    const googlecreds = this.route.snapshot.queryParams['googlecreds'];

    if (googlecreds) {
      this.handleSignInWithGoogle(decodeURIComponent(googlecreds));
    }
    if (this.userDetails) {
      // this.router.navigate(['/'])
      return;
    }

    if (currentUrl !== "/login" && currentUrl !== "/signup") {
      this.isModal = true;
    }

    if (currentUrl === "/login" && !this.isModal) {
      this.loginpage = true;
      this.signuppage = false;

    } else if (!this.isModal) {
      this.loginpage = false;
      this.signuppage = true;

    }

    this.signupForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email],],
      password: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/), Validators.minLength(8)]],
      confirmPassword: ['', [
        Validators.required]],
    });


  }

  goTo(url: string) {
    this.router.navigate([url])
  }


  async onLogin() {
    if (!this.loginLoader) {
      this.loginSubmit = true;
      if (this.loginForm.valid) {
        this.loginLoader = true;
        this.loginForm.disable();
        let response;
        try {
          response = await firstValueFrom(
            this.loginsignupService.signInWithEmailAndPassword(
              this.loginForm.value.email,
              this.loginForm.value.password
            )
          );

          if (this.tagManagerId) {
            gtag('event', 'login', {
              'value': this.loginForm.value.email
            });
          }

          if (response?.token) {
            const token = response.token;
            const refreshToken = response.refreshToken;
            const user = await firstValueFrom(
              this.loginsignupService.getUserbyAccessToken(token, refreshToken)
            );

            if (user?.email) {
              const date = new Date();
              date.setTime(user.accessToken.expiry);
              localStorage.setItem('token', user.accessToken.token);
              localStorage.setItem(
                'refreshToken',
                user.accessToken.refreshToken
              );
              document.cookie =
                `token= ${user.accessToken.token}; domain=.roamto.com; expires=` +
                date +
                `; SameSite=none; Secure=false`;
              document.cookie =
                `refreshToken= ${user.accessToken.refreshToken}; domain=.shamal.com; expires=` +
                date +
                `; SameSite=none; Secure=false`;
              this.storage.setUser(user);
              this.dialog.closeAll();
              if (this.appContext.siteName === 'alldotgay') {
                this.goTo('/');
              } else if (this.storage.getUrl()) {
                this.goTo(this.storage.getUrl());
              } else {
                this.goTo('/');
              }
            }
          }
        } catch (err: any) {
          console.error("login err: ");

          console.error(err);

          this.toasterSvc.error(
            err.error.errorMessage || err.error.title || err.error.code || 'Something went wrong!'
          );
        }
        this.loginLoader = false;
        this.loginForm.enable();
      }
    }
  }

  async onSignUp() {
    if (this.signupForm.value.password !== this.signupForm.value.confirmPassword) {
      this.toasterSvc.error("Confirmation password does not match");
      return;
    }
    if (!this.Showloader) {
      this.signupSubmit = true;
      if (this.signupForm.valid) {
        this.Showloader = true;
        this.signupForm.disable();
        try {
          const userDetails = {
            email: this.signupForm.value.email,
            password: this.signupForm.value.password
          };
          const responsesignup = await firstValueFrom(
            this.loginsignupService.registerUser(userDetails)
          );

          if (this.tagManagerId) {
            gtag('event', 'sign_up', {
              'value': this.loginForm.value.email
            });
          }
          this.dialog.closeAll();
          this.router.navigate(['onboard']);
        } catch (err: any) {
          this.toasterSvc.error(
            err.error.errorMessage || err.error.title || err.error.code || 'Something went wrong!'
          );
        }

        this.Showloader = false;
        this.signupForm.enable();
      }
    }
  }

}
(window as any).handleSignInWithGoogle = (response: any) => {
  handleSignInWithGoogle(response);
};

function handleSignInWithGoogle(response: any) {
  window.location.href = '/login?googlecreds=' + encodeURIComponent(response.credential);
}
